import {createContext, ReactNode, useCallback, useContext, useState} from 'react';
import {ConditionId, UserId} from '@legit.health/ui';
import useModal from '@/shared/hooks/useModal';
import DiagnosticReportFormModal from './DiagnosticReportFormModal';

type FormOptions = {
  conditionId?: ConditionId | null;
  patientId?: UserId | null;
};

type ContextType = (values: FormOptions & {patientId: UserId}) => void;

const Context = createContext<ContextType>(() => {});

export function DiagnosticReportFormModalContextProvider({children}: {children: ReactNode}) {
  const [modalProps, setModalProps] = useState<FormOptions>({});
  const modal = useModal(false, () => setModalProps({}));

  const open = useCallback<ContextType>(
    function (values) {
      setModalProps(values);
      modal.open();
    },
    [modal]
  );

  const handleSuccess = useCallback(
    function () {
      modal.close();
    },
    [modal]
  );

  return (
    <Context.Provider value={open}>
      {modalProps.patientId && (
        <DiagnosticReportFormModal
          modal={modal}
          patientId={modalProps.patientId}
          conditionId={modalProps.conditionId}
          onSuccess={handleSuccess}
        />
      )}
      {children}
    </Context.Provider>
  );
}

export function useDiagnosticReportFormModalContext() {
  return useContext(Context);
}
